var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',[_vm._t("default",null,{"loading":_vm.loading,"Item":_vm.Item,"title":_vm.title,"backLink":_vm.backLink,"refresh":_vm.refresh})],2):_c('v-progress-circular',{attrs:{"indeterminate":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }